import React from 'react';
import Avatars from './Avatars'

function RecentLogins({logins, onClick, onDelete}) {
    return (
        <div className='mt-4' style={{fontSize:'0.8rem'}}>
            <div className='fw-bold'>Recent Logins</div>
            <div className='recent-login border mt-3'>
                {
                    logins.map((user, index)=>{
                        return (
                            <div onClick={()=>onClick(user)} className='user' key={index}>
                                <div className='text-truncate'>
                                    <img src={Avatars[index%6]} alt='Avatar' className='me-2' style={{maxWidth:25, borderRadius: 25}}/>
                                    {user}
                                </div>
                                <div className='h-100' onClick={(e)=>onDelete(e,user)}>
                                    <svg className="bi bi-x-circle-fill" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path></svg>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

export default RecentLogins;